/* eslint-disable @typescript-eslint/no-explicit-any */
import { trpc } from 'pos-client/utils/trpc.ts';
import type {
  SettingGroupFindFERequestModel,
  SettingGroupWithSettingsFindFERequestModel,
  SettingsByPathFindFERequestModel,
} from 'pos-shared/models/settingsSchema.ts';
import { time } from 'pos-shared/utils/millisecondsHelper';

export const useSettingGroups = (request?: SettingGroupFindFERequestModel) => {
  const response = trpc.settings.findSettingGroups.useQuery(
    {
      ...request,
    } as SettingGroupFindFERequestModel,
    {
      cacheTime: time.oneDayInMilliseconds,
      staleTime: time.tenSecs,
    } as any
  );

  const {
    data,
    isLoading: isLoadingSettingGroups,
    isFetching: isFetchingSettingGroups,
    ...rest
  } = response;

  const settingGroups = data?.results ?? [];

  return {
    settingGroups,
    isLoadingSettingGroups,
    isFetchingSettingGroups,
    ...rest,
  };
};

export const useSettingGroupsWithSettings = (
  request?: SettingGroupWithSettingsFindFERequestModel
) => {
  const response = trpc.settings.findSettingGroupsWithSettings.useQuery(
    {
      ...request,
    } as SettingGroupWithSettingsFindFERequestModel,
    {
      cacheTime: time.oneDayInMilliseconds,
      staleTime: time.tenSecs,
    } as any
  );

  const {
    data,
    isLoading: isLoadingSettings,
    isFetching: isFetchingSettings,
    ...rest
  } = response;

  return {
    settings: data?.results ?? [],
    paging: {
      totalResults: data?.totalResults ?? 0,
      hasMoreResults: data?.hasMoreResults ?? false,
      pageNumber: data?.pageNumber ?? 1,
      resultsPerPage: data?.resultsPerPage ?? 10,
      totalPages: data?.totalPages ?? 1,
    },
    isLoadingSettings,
    isFetchingSettings,
    ...rest,
  };
};

export const useSettingsByPath = (
  request?: SettingsByPathFindFERequestModel
) => {
  const response = trpc.settings.findSettingsByPath.useQuery(
    {
      ...request,
    } as SettingsByPathFindFERequestModel,
    {
      cacheTime: time.oneDayInMilliseconds,
      staleTime: time.tenSecs,
    } as any
  );

  const {
    data,
    isLoading: isLoadingSettings,
    isFetching: isFetchingSettings,
    ...rest
  } = response;

  const settings = data ?? [];

  return {
    settings,
    first: (settings?.length ?? 0) ? settings[0] : undefined,
    isLoadingSettings,
    isFetchingSettings,
    ...rest,
  };
};
